module.exports = __webpack_public_path__ + "static/media/tree1975.d5d2d7d2.jpg";